import TermsAndConditionsDocument from '../../modules/legal/TermsAndConditionsDocument';

export default TermsAndConditionsDocument;
